import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
    Color,
    Icons,
    Masks,
    Modal,
    ModalServiceToken,
    Unmasks,
    LsqValidators,
    ModalService
} from '@lsq-frontend/common-ui';

@Component({
    selector: 'edit-phone-modal',
    templateUrl: './edit-phone-modal.component.html',
    styleUrls: ['./edit-phone-modal.component.scss']
})
export class EditPhoneModal {
    public modal: Modal;
    public icons = Icons;
    public color = Color;
    public formGroup: FormGroup;
    public readonly phoneMask = Masks.PhoneMask;
    public readonly phoneUnmask = Unmasks.PhoneUnmask;
    public readonly edit_phone_subtitle: string =
        'To verify your identity, we will use this number to send a one-time verification code via SMS.';
    public isSubmitting: boolean;
    constructor(
        @Inject(ModalServiceToken) public modalService: ModalService,
        private fb: FormBuilder
    ) {
        this.modal = this.modalService.modal;
        this.formGroup = this.fb.group({
            phoneNumber: new FormControl(this.modal.data.fieldValue.fieldValue, [
                Validators.required,
                LsqValidators.phone
            ])
        });
        this.submitting();
    }

    public confirmModal(): void {
        this.modal.data.fieldValue.fieldValue = this.formGroup.value?.phoneNumber;
        this.modal.onOkClick();
    }

    public submitting() {
        this.modal.isSubmitting$.subscribe((value) => (this.isSubmitting = value));
    }
}
